// extracted by mini-css-extract-plugin
export default {"shell":"App_shell__1G2Ca","main":"App_main__nhgh3"};